// Source/evidence label helpers shared by PostDetail and IncidentDetail.
// Extracted in the sub-sprint 4 fix sprint so both pages produce consistent
// "Primary Source"/"Secondary Source" labels and the same origin-type icons.
// EvidenceItem and ReplyCard extraction is deferred per the cheap-path plan.

export const QUALITY_LABEL = { strong: 'Strong', moderate: 'Moderate', weak: 'Weak', very_weak: 'Very weak' };
export const QUALITY_COLOR = { strong: 'var(--color-verified)', moderate: 'var(--color-new)', weak: 'var(--color-disputed)', very_weak: 'var(--color-invalidated)' };
export const QUALITY_BG    = { strong: 'var(--color-verified-bg)', moderate: 'var(--color-new-bg)', weak: 'var(--color-disputed-bg)', very_weak: 'var(--color-invalidated-bg)' };

export const ORIGIN_TYPE_ICON = {
  original_data_with_methodology: '🔬',
  original_data_no_methodology:   '📊',
  citing_other_source:            '🔗',
  anonymous_source:               '👤',
  quoted_text:                    '💬',
  assertion_only:                 '💭',
};

export function getDomain(url) {
  try { return new URL(url).hostname.replace(/^www\./, ''); } catch { return url.slice(0, 30); }
}

// Unified source badge — prefers status/url over source_origin_type.
// Accepts evidence_check-shaped objects (PostDetail) OR sources-table rows
// (IncidentDetail). Sources rows don't carry `status`/`evidence_url`, so we
// fall through to source_origin_type — which is enough to label them.
export function getSourceBadge(ec) {
  const url = ec.evidence_url || ec.url;
  if (!url) {
    return { label: 'Claimed', color: '#92400e', bg: '#fef3c7' };
  }
  if (ec.status === 'paywall') {
    return { label: 'Paywalled', color: '#92400e', bg: '#fef3c7' };
  }
  if (ec.status === 'unscrapeable' || ec.status === 'inaccessible') {
    return { label: 'Inaccessible', color: '#92400e', bg: '#fef3c7' };
  }
  switch (ec.source_origin_type) {
    case 'peer_reviewed':
    case 'primary_source':
      return { label: 'Primary Source', color: '#15803d', bg: '#f0fdf4' };
    case 'secondary_source':
      return { label: 'Secondary Source', color: '#1d4ed8', bg: '#eff6ff' };
    default:
      return { label: 'Inaccessible', color: '#92400e', bg: '#fef3c7' };
  }
}
